var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryStatuses01 = function SvgDeliveryStatuses01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "delivery_statuses-01_svg2__a",
    x1: 72.58,
    x2: 241.99,
    y1: 204.22,
    y2: 41.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__b",
    x1: 51.41,
    x2: 220.82,
    y1: 182.17,
    y2: 19.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__c",
    x1: 66.56,
    x2: 235.97,
    y1: 197.96,
    y2: 35.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__d",
    x1: 66.57,
    x2: 235.14,
    y1: 197.96,
    y2: 36.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__e",
    x1: 66.58,
    x2: 152.05,
    y1: 197.97,
    y2: 115.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__f",
    x1: 66.55,
    x2: 235.96,
    y1: 197.94,
    y2: 35.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__g",
    x1: 38.19,
    x2: 126.5,
    y1: 168.4,
    y2: 83.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__h",
    x1: 74.24,
    x2: 76.47,
    y1: 135.52,
    y2: 133.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__i",
    x1: 38.31,
    x2: 80.14,
    y1: 168.52,
    y2: 128.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__j",
    x1: 37.88,
    x2: 131.4,
    y1: 168.08,
    y2: 78.29
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__k",
    x1: 63.16,
    x2: 71.79,
    y1: 143.1,
    y2: 134.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__l",
    x1: 40.1,
    x2: 209.51,
    y1: 170.39,
    y2: 7.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__m",
    x1: 38.29,
    x2: 113.64,
    y1: 168.51,
    y2: 96.18
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__n",
    x1: 38.3,
    x2: 207.72,
    y1: 168.52,
    y2: 5.88
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__o",
    x1: 38.26,
    x2: 132.27,
    y1: 168.47,
    y2: 78.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__p",
    x1: 66.53,
    x2: 235.94,
    y1: 197.92,
    y2: 35.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__q",
    x1: 66.52,
    x2: 235.93,
    y1: 197.91,
    y2: 35.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__r",
    x1: 66.53,
    x2: 235.94,
    y1: 197.92,
    y2: 35.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__s",
    x1: 66.55,
    x2: 235.96,
    y1: 197.95,
    y2: 35.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__t",
    x1: 66.56,
    x2: 235.97,
    y1: 197.95,
    y2: 35.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__u",
    x1: 32.8,
    x2: 202.21,
    y1: 162.78,
    y2: 0.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__v",
    x1: -28.47,
    x2: 140.94,
    y1: 98.96,
    y2: -63.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__w",
    x1: -21.24,
    x2: 148.17,
    y1: 106.5,
    y2: -56.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__x",
    x1: -14.01,
    x2: 155.41,
    y1: 114.03,
    y2: -48.61
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__y",
    x1: 4.56,
    x2: 173.97,
    y1: 133.37,
    y2: -29.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__z",
    x1: 23.06,
    x2: 192.47,
    y1: 152.64,
    y2: -9.99
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#delivery_statuses-01_svg2__a",
    id: "delivery_statuses-01_svg2__A",
    x1: 21.46,
    x2: 190.87,
    y1: 150.97,
    y2: -11.66
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M74.82 179.86c0 2.3 1.86 4.17 4.17 4.17h37.93c2.3 0 4.17-1.87 4.17-4.17s-1.86-4.17-4.17-4.17H78.99c-2.3 0-4.17 1.87-4.17 4.17",
    style: {
      fill: "url(#delivery_statuses-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.86 175.69h-10.1c-2.3 0-4.17 1.87-4.17 4.17s1.86 4.17 4.17 4.17h10.1c2.3 0 4.17-1.87 4.17-4.17s-1.86-4.17-4.17-4.17",
    style: {
      fill: "url(#delivery_statuses-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.23 105.16s-.03.02-.04.03c.01-.01.03-.02.04-.03",
    style: {
      fill: "url(#delivery_statuses-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.29 105.11s-.02.01-.02.02c0 0 .02-.01.02-.02",
    style: {
      fill: "url(#delivery_statuses-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.37 105.06h.01z",
    style: {
      fill: "url(#delivery_statuses-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.04 105.31.02-.02s.02-.01.03-.02c-.02.01-.03.03-.05.04",
    style: {
      fill: "url(#delivery_statuses-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.27 139.55s-.01 0-.02-.01-.03-.02-.04-.03c.03.02.05.04.08.06 0 0-.01 0-.02-.01Z",
    style: {
      fill: "url(#delivery_statuses-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.36 134.45v-.01z",
    style: {
      fill: "url(#delivery_statuses-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.41 139.66s-.02-.02-.04-.03c.01.01.03.02.04.03",
    style: {
      fill: "url(#delivery_statuses-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.93 139.3s-.05-.04-.08-.06c.03.02.05.04.08.06",
    style: {
      fill: "url(#delivery_statuses-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.47 138.95",
    style: {
      fill: "url(#delivery_statuses-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.46 78.04-20.74-15.68V16.68c0-9.2-7.48-16.68-16.68-16.68H44.97c-9.2 0-16.68 7.48-16.68 16.68v45.67L7.54 78.04C2.69 81.69.02 87.64.02 93.15v87.87C.02 191.34 8.44 200 19 200h162.01c10.89 0 18.98-9.07 18.98-18.98V93.15c0-5.52-2.63-11.43-7.52-15.1Zm-20.74-5.22c16.4 12.49 15.67 11.64 17.02 13.09l-17.02 12.83zM36.63 16.68c0-4.6 3.74-8.34 8.34-8.34h110.08c4.6 0 8.34 3.74 8.34 8.34v11.78H36.63zm0 20.12h126.75v.2-.04.72-.03 67.4l-.01.01c-.02.02-.04.03-.06.05 0 0-.02.01-.03.02s-.03.02-.04.03c-.02.01-.03.03-.05.04 0 0-.02.01-.02.02h-.01c-.02.02-.05.04-.07.05 0 0-.02.01-.03.02-.03.02-.06.05-.09.07.02-.02.04-.03.07-.05q-.075.045-.15.12s-.01 0-.02.01c-.02.01-.03.03-.05.04 0 0-.02.01-.03.02 0 0-.01 0-.02.01s-.02.01-.02.01c-2.1 1.59-10.33 7.84-38.1 28.92l-12.93-9.82c-6.89-5.16-16.53-5.16-23.45.02-.39.3-12.18 9.25-12.91 9.8h-.01c-.24-.18-3.55-2.69-38.71-29.31V36.8Zm126.31 68.58s-.01 0-.01.01zm-94.5 34.3-.01-.01zM12.57 84.7l15.71-11.88v25.99L11.25 85.92c.41-.44.84-.86 1.32-1.22m-4.21 96.32V94.18l59.11 44.76.08.06c-.03-.02-.06-.04-.07-.05.14.11.26.2.37.28-.01 0-.02-.02-.03-.03.04.03.07.06.12.09.01.01.03.02.04.03.1.07.17.13.24.18-.01 0-.02-.02-.04-.03.02.02.05.04.08.06 0 0 .01 0 .02.01.05.03.09.07.14.11.01 0 .02.02.03.02l-59.43 45c-.43-1.15-.66-2.38-.66-3.66Zm59.29-41.93.11.08c-.04-.03-.08-.06-.11-.08m.33.24s.06.05.09.07c-.03-.02-.06-.05-.09-.07m.14.11s.04.03.06.04c-.02-.01-.04-.03-.06-.04M181 191.66H19c-1.38 0-2.79-.28-4.2-.89l1.48-1.12.02-.01c.02-.01.04-.03.05-.04 0 0-.01 0-.02.01 0 0 .02-.01.03-.02 0 0 .02-.01.03-.02s.03-.02.05-.04c.01 0 .03-.02.04-.03 0 0 .02-.01.02-.02 0 0 .02-.01.03-.02q.03-.03 0 0c1.7-1.29 13.2-9.99 76.75-58.12 4.01-3.01 9.54-2.93 13.42-.01 45.64 34.56 57.21 43.33 78.51 59.45-1.45.63-2.88.89-4.2.89Zm10.64-10.64c0 1.28-.23 2.51-.66 3.66l-59.43-45c9.74-7.39 17.4-13.21 23.37-17.74-2.32 1.77 4.38-3.28 36.73-27.78v86.85Z",
    style: {
      fill: "url(#delivery_statuses-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.27 189.65h.01z",
    style: {
      fill: "url(#delivery_statuses-01_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.42 189.53s-.03.02-.05.04c0 0-.02.01-.03.02l-.01.01c.03-.02.06-.05.09-.07",
    style: {
      fill: "url(#delivery_statuses-01_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.37 139.63s-.05-.04-.08-.06c.03.02.06.05.08.06",
    style: {
      fill: "url(#delivery_statuses-01_svg2__o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.83 105.46s.02-.01.03-.02c0 0-.02.01-.03.02",
    style: {
      fill: "url(#delivery_statuses-01_svg2__p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.78 105.5s.02-.01.03-.02h.01c-.02.01-.03.02-.05.03Z",
    style: {
      fill: "url(#delivery_statuses-01_svg2__q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.87 105.43h.01s-.02.01-.03.02h.01Z",
    style: {
      fill: "url(#delivery_statuses-01_svg2__r)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.09 105.27s.03-.02.05-.04c-.02.01-.03.02-.05.04",
    style: {
      fill: "url(#delivery_statuses-01_svg2__s)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.16 105.22s-.02.01-.03.02l.02-.02Z",
    style: {
      fill: "url(#delivery_statuses-01_svg2__t)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.39 37.39v.05z",
    style: {
      fill: "url(#delivery_statuses-01_svg2__u)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.46 14.03c-2.3 0-4.39 2.07-4.39 4.37s2.08 4.37 4.39 4.37 4.37-2.07 4.37-4.37-2.07-4.37-4.37-4.37",
    style: {
      fill: "url(#delivery_statuses-01_svg2__v)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.53 14.03c-2.3 0-4.39 2.07-4.39 4.37s2.08 4.37 4.39 4.37 4.37-2.07 4.37-4.37-2.06-4.37-4.37-4.37",
    style: {
      fill: "url(#delivery_statuses-01_svg2__w)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.61 14.03c-2.3 0-4.39 2.07-4.39 4.37s2.08 4.37 4.39 4.37 4.37-2.07 4.37-4.37-2.06-4.37-4.37-4.37",
    style: {
      fill: "url(#delivery_statuses-01_svg2__x)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.78 14.23h-40.91c-2.3 0-4.17 1.87-4.17 4.17s1.86 4.17 4.17 4.17h40.91c2.3 0 4.17-1.87 4.17-4.17s-1.86-4.17-4.17-4.17",
    style: {
      fill: "url(#delivery_statuses-01_svg2__y)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.01 112.42c18.55 0 33.64-15.09 33.64-33.64s-15.09-33.64-33.64-33.64-33.64 15.09-33.64 33.64 15.09 33.64 33.64 33.64m0-58.94c13.95 0 25.3 11.35 25.3 25.3s-11.35 25.3-25.3 25.3-25.3-11.35-25.3-25.3 11.35-25.3 25.3-25.3",
    style: {
      fill: "url(#delivery_statuses-01_svg2__z)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.97 89.25c1.22 1.22 2.82 1.83 4.42 1.83s3.21-.61 4.43-1.83l15.65-15.65a4.17 4.17 0 0 0 0-5.9 4.17 4.17 0 0 0-5.9 0L95.39 81.88l-4.95-4.95a4.17 4.17 0 0 0-5.9 0 4.17 4.17 0 0 0 0 5.9l6.43 6.43Z",
    style: {
      fill: "url(#delivery_statuses-01_svg2__A)"
    }
  }));
};
export default SvgDeliveryStatuses01;